<script setup>
import { computed } from 'vue';
import { DateTime } from 'luxon';

const props = defineProps({
  startDate: {
    type: String,
  },
  endDate: {
    type: String,
  },
  timezone: {
    type: String,
  },
  state: {
    type: String,
  },
  city: {
    type: String,
  },
  isVirtual: {
    type: Boolean,
  },
});

const formattedStartDate = computed(() => {
  return props.startDate ? DateTime.fromISO(props.startDate).toFormat('cccc, LLLL d, yyyy') : '';
});

const formattedEndDate = computed(() => {
  return props.endDate ? DateTime.fromISO(props.endDate).toFormat('cccc, LLLL d, yyyy') : '';
});

const multiDay = computed(() => {
  if (!props.startDate || !props.endDate) return false;
  return !DateTime.fromISO(props.startDate)
    .startOf('day')
    .equals(DateTime.fromISO(props.endDate).startOf('day'));
});

const formattedTimeRange = computed(() => {
  if (!props.startDate || !props.endDate) return '';
  const start = DateTime.fromISO(props.startDate).setZone(props.timezone);
  const end = DateTime.fromISO(props.endDate).setZone(props.timezone);
  return `${start.toFormat('h:mm a')} - ${end.toFormat('h:mm a')} (${end.toFormat('ZZZZ')})`;
});
</script>

<template>
  <div class="event-details d-flex flex-wrap fs-14">
    <div class="mr-3">
      <v-icon
        size="x-small"
        variant="default"
        icon="mdi-calendar-blank-outline"
        class="mr-2 color-neutral-400"
      />
      <span>{{ formattedStartDate }}</span>
      <span v-if="multiDay"> - {{ formattedEndDate }}</span>
    </div>

    <div v-if="!multiDay" class="mr-3">
      <v-icon
        size="x-small"
        variant="default"
        icon="mdi-clock-time-four-outline"
        class="mr-2 color-neutral-400"
      />
      <span>{{ formattedTimeRange }}</span>
    </div>
    <div v-if="!isVirtual && city && state">
      <v-icon
        size="x-small"
        variant="default"
        icon="mdi-map-marker-outline"
        class="mr-2 color-neutral-400"
      />
      <span>{{ city }}, {{ state }}</span>
    </div>
  </div>
</template>

<style scoped>
.event-details {
  font-weight: 500;
  align-items: center;
}
@media (max-width: 599px) {
  .event-details {
    flex-direction: column;
    white-space: normal;
  }
}
</style>
